module.exports = __webpack_public_path__ + "img/blue-ball.574ea450.webp";